export const SHOPPING_CART_QUERY_KEY = "shoppingCart";
export const SHOPPING_CART_LINES_QUERY_KEY = "shoppingCartLines";
export const CART_PRODUCT_THUMBNAILS_QUERY_KEY = "cartProductThumbnails";
export const CART_PRODUCT_AVAILABILITY_QUERY_KEY = "cartProductAvailability";
export const ORG_UNIT_LOGO_QUERY_KEY = "orgUnitLogo";
export const ORG_UNIT_LOGO_INFO_QUERY_KEY = "orgUnitLogoInfo";
export const TOP_NAV_MENU_QUERY_KEY = "topNavMenu";
export const USER_PROFILE_DRAWER_QUERY_KEY = "userProfileDrawer";
export const ACCOUNT_PROFILE_DRAWER_QUERY_KEY = "accountProfileDrawer";